import { render, staticRenderFns } from "./mail-template.vue?vue&type=template&id=227a90c2&scoped=true"
import script from "./mail-template.vue?vue&type=script&lang=ts"
export * from "./mail-template.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227a90c2",
  null
  
)

export default component.exports